import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MatContactLogRepository } from '../repositories/mat-contact-log.repository';
import {
  CreateMatContactLogPayload,
  CreateMatContactLogResponse,
  MatContactLogPage
} from '../models/mat-contact-log.model';

/**
 * Service wrapper for the MAT contact-log repository. Thin pass-through today;
 * exists so callers can stay decoupled from HTTP details and so future business logic
 * (caching, optimistic refresh, etc.) has a single home.
 */
@Injectable({ providedIn: 'root' })
export class MatContactLogService {
  private readonly repo = inject(MatContactLogRepository);

  createContact(accountId: string, payload: CreateMatContactLogPayload): Observable<CreateMatContactLogResponse> {
    return this.repo.createContact(accountId, payload);
  }

  listContacts(accountId: string, options?: { page?: number; pageSize?: number }): Observable<MatContactLogPage> {
    return this.repo.listContacts(accountId, options);
  }
}
